import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    // {
    //   path: "/",
    //   name: "index",
    //   component: () => import("@/view/index.vue"),
    //   meta: {
    //     title: '莽林斗士'
    //   }
    // },
    // {
    //   path: "/",
    //   name: "index",
    //   component: () => import("@/view/horizontal.vue"),
    //   meta: {
    //     title: '莽林斗士'
    //   }
    // },
    // {
    //   path: "/perpendicular",
    //   name: "index",
    //   component: () => import("@/view/index.vue"),
    //   meta: {
    //     title: '莽林斗士'
    //   }
    // }
    // {
    //   path: '/',
    //   name: 'index',
    //   component: () => import('@/view/index.vue'),
    //   meta: {
    //     title: ''
    //   }
    // },
    // {
    //   path: '/start',
    //   name: 'start',
    //   component: () => import('@/view/start.vue'),
    //   meta: {
    //     title: ''
    //   }
    // },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js